<template>
  <div class="edit-information">
    <p class="edit-info-title">Aangemaakt</p>
    <template v-if="value.createdBy">
      <p>{{ value.createdBy.firstname }} {{ value.createdBy.lastname }}</p>
    </template>
    <p>{{ value.created_at | time-day }}</p>
    <hr v-if="value.lastEditedBy">
    <template v-if="value.lastEditedBy">
      <p class="edit-info-title">Laatst bewerkt door</p>
      <p>{{ value.createdBy.firstname }} {{ value.createdBy.lastname }}<br>
        {{ value.updated_at | time-day }}</p>
    </template>
    <hr v-if="getLastPlacedBy && getLastPlacedBy.placedBy">
    <template v-if="getLastPlacedBy && getLastPlacedBy.placedBy">
      <p class="edit-info-title">Laatst geplaatst door</p>
       <p :key='"placement"+idx' v-for="(by,idx) in getLastPlacedBy.placedBy">
        {{ by.displayName }}
      </p>

      <p>{{ getLastPlacedBy.created_at | time-day }}</p>
    </template>
    <hr v-if="getLastContactMoment">
    <template v-if="getLastContactMoment">
      <p class="edit-info-title">Laatste bezoek door</p>
      <p>{{ getLastContactMoment.user.firstname }} {{ getLastContactMoment.user.lastname }}</p>
      <p>{{ getLastContactMoment.created_at | time-day }}</p>
    </template>
    <hr v-if="customer">
    <template v-if="customer">
      <p class="edit-info-title">Verantwoordelijke</p>
      <p v-if="value.responsibleUser">{{ value.responsibleUser.firstname }} {{ value.responsibleUser.lastname }}</p>
      <p v-else>Niet toegewezen</p>
    </template>
    <hr>
    <button v-if=customer @click="saveContactMoment" class="btn btn-primary w-100">Bezoek</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: Object,
    placements: Array,
    customer:Boolean,
    customerContactMoments: Array
  },
  computed: {
    ...mapGetters(['getUserData']),
    getLastPlacedBy() {
      console.log(this.placements)
      return this.placements ? _.orderBy(this.placements , 'created_at','desc')[0] : null
    },
    getLastContactMoment() {
      return this.customerContactMoments ? _.orderBy(this.customerContactMoments, 'created_at', 'desc')[0] : null
    }
  },
  methods: {
    saveContactMoment() {
      const user = this.getUserData;
      console.log('USER',user)
      this.$emit('saveContactMoment', {
        user: {
          id: user.id,
          firstname: user.firstname,
          lastname: user.lastname,
        },
        created_at: new Date(),
      });
    }
  }
}
</script>
